module.exports = __webpack_public_path__ + "img/select-arrow.c51a5470.svg";